import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CalendarClock } from "lucide-react";

export default function Login() {
  const { login, error, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex flex-col justify-between p-12 bg-slate-950 text-slate-100 relative overflow-hidden">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-blue-500 flex items-center justify-center">
            <CalendarClock className="h-5 w-5" />
          </div>
          <span className="font-display text-xl font-bold">Meridiana</span>
        </div>
        <div className="relative z-10">
          <h1 className="font-display text-4xl lg:text-5xl font-bold leading-tight tracking-tight">
            Il calendario dei consulenti,<br />
            <span className="text-blue-400">senza compromessi.</span>
          </h1>
          <p className="mt-6 text-slate-400 max-w-md text-base">
            Prenotazioni, esiti, note post-incontro e statistiche multi-collaboratore in un'unica interfaccia in stile Google Calendar.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-3 max-w-md">
            {["Da svolgere", "Effettuato", "No-Show", "Annullato", "Riprogrammato", "CSV Export"].map((t) => (
              <div key={t} className="text-xs uppercase tracking-widest font-semibold text-slate-400 border border-slate-800 rounded px-2 py-2 text-center">
                {t}
              </div>
            ))}
          </div>
        </div>
        <div className="text-xs text-slate-500">© 2026 Meridiana Booking</div>
        <div className="absolute -right-24 -bottom-24 w-96 h-96 rounded-full bg-blue-600/20 blur-3xl" />
      </div>

      <div className="flex items-center justify-center p-8 bg-background">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <h2 className="font-display text-3xl font-bold tracking-tight">Accedi</h2>
            <p className="text-sm text-muted-foreground mt-1">Benvenuto. Inserisci le tue credenziali.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@azienda.com"
              required
              data-testid="login-email-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}
          <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit-button">
            {loading ? "Accesso…" : "Accedi"}
          </Button>
          <div className="text-xs text-muted-foreground text-center">
            Solo gli amministratori possono creare nuovi account collaboratore.
          </div>
        </form>
      </div>
    </div>
  );
}
